import { createSlice } from "@reduxjs/toolkit";

export const recaptchaSlice = createSlice({
	name: "recaptcha",
	initialState: {
		siteKey: "",
	},
	reducers: {
		setRecaptcha: (state, action) => {
			state.siteKey = action.payload.siteKey;
		},
	},
});

export const { setRecaptcha } = recaptchaSlice.actions;
